
export default {
  methods: {
    login() {
      const urlInternoProd = 'https://app.senhadigitalplus.com.br'
      const urlInternoDev = 'https://dev.senhadigitalplus.com.br'

      const url = this.$isDev ? urlInternoDev : urlInternoProd

      window.open(url, '_blank')
    },
  },
}
